import React from "react";
import Exhibitors from "./Exhibitors";
import Products from "./Products";
import Matchmaking from "./Matchmaking";
import Visitors from "./Visitors";
import News from "./News";
import { Route, Routes, useParams } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
const Explore = () => {
  return (
    <Box>
      {/* <NewDashHeader /> */}
      <Box m={1} p={1}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Routes>
              <Route path="" element={<Exhibitors />} />
              <Route path="exhibitors-list" element={<Exhibitors />} />
              <Route path="products" element={<Products />} />
              <Route path="ai-matching" element={<Matchmaking />} />
              <Route path="visitors" element={<Visitors />} />
            </Routes>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Explore;
